var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"column":_vm.col.id,"scope":"col"}},[_c('span',{class:{sortable: _vm.col.isSortable},on:{"click":_vm.onCellClicked}},[_vm._v(" "+_vm._s(_vm.col.label)+" "),(_vm.col.isSortable)?_c('sort-icon',{attrs:{"dir":_vm.sortDir}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }